import axios from "axios";
import { instance } from "../network/ApiCall";

export async function fetchCountryListModule() {
  const response = await instance.get( "/country/getCountryList");
  return response.data;
}
export async function fetchCompanyListModule() {
    const response = await instance.get( "/admin/company/get");
    return response.data;
  }
  export async function fetchLocationListModule(groupId:any) {
    const response = await instance.get( `/location/getLocationList?companyId=${groupId}`);
    return response.data;
  }
  export async function fetchgiftDeclarationsModule(data:any) {
    const response = await instance.get( `/declaration/gift/get?id=${data.userId}&keyword=${data.keyword}`);
    return response.data;
  }
  export async function fetchLectureDeclarationsModule(data:any) {
    const response = await instance.get( `/declaration/lecture/get?id=${data.userId}&keyword=${data.keyword}`);
    return response.data;
  }
  export async function setGift(data:any) {
    const response = await instance.post( `/declaration/gift/insert`, data);
    return response.data;
  }
  export async function setLecture(data:any) {
    const response = await instance.post( `/declaration/lecture/insert`, data);
    return response.data;
  }
  export async function giftLectureSearchModule(data:any) {
    const response = await instance.get( `/declaration/${data.gift}?search=${data.search}`);
    return response.data;
  }
  export async function fetchYearList() {
    const response = await instance.get( "/admin/year/get");
    return response.data;
  }
  export async function fetchCounsellorSearch(data:any) {
    const response = await instance.post( `/counselor/getAllCounselorDetails?groupId=${data.company}&locationId=${data.location}`);
    return response.data;
  }

  export async function fetchCounsellors(data:any) {
    const response = await instance.get( `/admin/ethicsCounsellorsList/get?companyId=${data.companyId}&keyword=${data.keyword}`);
    return response.data;
  }
  export async function fetchContacts(data:any) {
    const response = await instance.get( `/counselor/ethicsTeams/getAll?companyId=${data.companyId}&keyword=${data.keyword}`);
    return response.data;
  }
  export async function fetchInsertEthicsTeamGroup(data:any) {
    const response = await instance.post( "/counselor/addEthicsTeamGroup", data);
    return response.data;
  }
  export async function fetchDeleteEthicsTeamGroup(data:any) {
    const response = await instance.post( "/counselor/deleteEthicsTeamGroup", data);
    return response.data;
  }
  export async function fetchInsertEthicsTeamGroupDetails(data:any) {
    const response = await instance.post( `/counselor/addEthicsTeamDetails/${data.id}`, data.data);
    return response.data;
  }
  export async function fetchDeleteEthicsTeamGroupDetails(data:any) {
    const response = await instance.delete( `/counselor/deleteEthicsTeamDetails/${data}`, );
    return response.data;
  }



  

  export async function fetchInsertCounsellorsList(data:any) {
    const response = await instance.post( "/counselor/addEthicsCounsellorGroup", data);
    return response.data;
  }
  
 
  export async function fetchdeleteethicsCounsellor(data:any) {
    const response = await instance.post( "/counselor/deleteEthicsCounsellorGroup", data);
    return response.data;
  }
  export async function fetchInsertCounsellorsListDetails(data:any) {
    const response = await instance.post( `/counselor/addEthicsCounsellorDetails/${data.id}`, data.data);
    return response.data;
  }
  export async function fetchdeleteethicsCounsellorDetails(data:any) {
    const response = await instance.delete( `/counselor/deleteEthicsCounsellorDetails/${data}`, );
    return response.data;
  }
  
  export async function fetchBusinessUnitListModule(data:any) {
    const response = await instance.get( `/material/getBU?sectorId=${data}` );
    return response.data;
  }
  export async function fetchSectorListModule() {
    const response = await instance.get( `/material/getAllSector` );
    return response.data;
  }
  export async function fetchCOISectorListAPI() {
    const response = await instance.get(`/coi/getCoiSector`);
    return response.data;
  }
  
  
  
  
  
  
  
  
  